{
  "title": "Niveaux de stock",
  "subtitle": "Ce que vous avez maintenant, dans chaque emplacement, et ce que ça vaut.",
  "subtitleSite": "Ce que vous avez maintenant dans ce site, endroit par endroit.",
  "export": "Exporter vers Excel",
  "totalValue": "Valeur totale du stock · tous emplacements",
  "tabs": {
    "all": "Tous les produits",
    "low": "Bas",
    "out": "En rupture",
    "negative": "Négatif",
    "overstock": "Surstock"
  },
  "matrix": "Produit × emplacement",
  "mode": "Afficher",
  "quantities": "Quantités",
  "values": "Valeurs (TND)",
  "search": "Produit, référence ou code-barres",
  "category": "Catégorie",
  "allCategories": "Toutes les catégories",
  "product": "Produit",
  "directly": "{{name}} (directement)",
  "total": "Total",
  "value": "Valeur (TND)",
  "valueOf": "Valeur {{value}} TND",
  "empty": "Aucun produit ne correspond",
  "legend": {
    "title": "Couleurs :",
    "negative": "Négatif",
    "low": "Au minimum ou en dessous",
    "out": "En rupture",
    "overstock": "Au-dessus du maximum",
    "never": "Jamais stocké ici"
  },
  "showing": "{{shown}} produits affichés sur {{total}}",
  "byCategory": "Valorisation par catégorie",
  "byCategoryHint": "Quantité × coût moyen pondéré · total {{total}} TND",
  "noCategory": "Sans catégorie",
  "productCount_one": "{{count}} produit",
  "productCount_many": "{{count}} produits",
  "productCount_other": "{{count}} produits",
  "reserved": "Réservé",
  "available": "Disponible",
  "reservedOf": "{{reserved}} réservé(s) pour des commandes · {{available}} disponible(s)",
  "limits": {
    "title": "Limites de stock",
    "subtitle": "Le minimum et le maximum de chaque produit et variante à un emplacement. À son minimum ou en dessous, une alerte « Stock bas » ; au-delà de son maximum, une alerte « Surstock ».",
    "location": "Emplacement",
    "tabsLabel": "Produits affichés",
    "tabs": {
      "all": "Tous les produits",
      "limited": "Avec limites"
    },
    "search": "Rechercher un produit, un SKU ou un code-barres",
    "allCategories": "Toutes les catégories",
    "allBrands": "Toutes les marques",
    "clear": "Effacer les filtres",
    "product": "Produit",
    "here": "Stock ici",
    "hereHint": "Un site compte ses sous-emplacements.",
    "min": "Min",
    "max": "Max",
    "state": "État",
    "changes_one": "{{count}} modification non enregistrée",
    "changes_many": "{{count}} modifications non enregistrées",
    "changes_other": "{{count}} modifications non enregistrées",
    "locked": "Enregistrez ou annulez les modifications avant de changer d'emplacement, de filtre ou de page.",
    "undo": "Annuler",
    "save": "Enregistrer les limites",
    "saved_one": "Limites enregistrées pour {{count}} produit.",
    "saved_many": "Limites enregistrées pour {{count}} produits.",
    "saved_other": "Limites enregistrées pour {{count}} produits.",
    "unchanged": "Rien n’a changé.",
    "fixErrors": "Certaines valeurs sont à vérifier.",
    "noPlace": "Vous n'avez aucun emplacement où fixer des limites.",
    "noMatch": {
      "title": "Aucun produit trouvé",
      "text": "Essayez une autre recherche ou un autre filtre."
    },
    "showing": "{{first}}–{{last}} sur {{total}} produits"
  }
}
